import $ from 'jquery';

const MOBILE_MEDIA_QUERY = '(max-width: 600px)';
const DESKTOP_CARDS_PER_SLIDE = 3;
const MOBILE_CARDS_PER_SLIDE = 2;
const SWIPE_THRESHOLD = 50;

export function initPosts() {
  const $section = $('.posts');

  if (!$section.length) {
    return;
  }

  const $list = $section.find('.posts__list');
  const $pagination = $section.find('.posts__pagination');
  const itemList = $section.find('.posts__item').toArray();

  if (!itemList.length) {
    return;
  }

  let current = Math.max(0, $section.find('.posts__dot.is-active').index());
  let cardsPerSlide = 0;

  function getCardsPerSlide() {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches
      ? MOBILE_CARDS_PER_SLIDE
      : DESKTOP_CARDS_PER_SLIDE;
  }

  function getSlideCount() {
    return Math.ceil(itemList.length / cardsPerSlide);
  }

  function activate(index) {
    const total = getSlideCount();

    if (total === 0) {
      return;
    }

    current = ((index % total) + total) % total;

    $list.children('.posts__slide').removeClass('is-active').eq(current).addClass('is-active');
    $pagination.children('.posts__dot').removeClass('is-active').eq(current).addClass('is-active');
  }

  function render(perSlide) {
    if (perSlide === cardsPerSlide) {
      return;
    }

    const firstItemIndex = current * (cardsPerSlide || perSlide);

    cardsPerSlide = perSlide;

    $(itemList).detach();
    $list.empty();
    $pagination.empty();

    for (let offset = 0; offset < itemList.length; offset += perSlide) {
      const $slide = $('<div class="posts__slide"></div>');

      $slide.append(itemList.slice(offset, offset + perSlide));
      $list.append($slide);
      $pagination.append('<button type="button" class="posts__dot"></button>');
    }

    activate(Math.floor(firstItemIndex / perSlide));
  }

  render(getCardsPerSlide());

  $pagination.on('click', '.posts__dot', function () {
    activate($pagination.children('.posts__dot').index(this));
  });

  $section.find('.posts__nav--prev').on('click', () => activate(current - 1));
  $section.find('.posts__nav--next').on('click', () => activate(current + 1));

  let swipeStartX = 0;
  let swipeStartY = 0;
  let swipeActive = false;

  $list.on('touchstart', function (e) {
    const t = e.originalEvent.touches[0];
    swipeStartX = t.clientX;
    swipeStartY = t.clientY;
    swipeActive = true;
  });

  $list.on('touchend', function (e) {
    if (!swipeActive) {
      return;
    }

    swipeActive = false;
    const t = e.originalEvent.changedTouches[0];
    const dx = t.clientX - swipeStartX;
    const dy = t.clientY - swipeStartY;

    if (Math.abs(dx) <= Math.abs(dy)) {
      return;
    }

    if (Math.abs(dx) < SWIPE_THRESHOLD) {
      return;
    }

    const direction = dx < 0 ? 1 : -1;
    activate(current + direction);
  });

  $(window).on('resize', () => render(getCardsPerSlide()));
}
